import React, { useState } from 'react';
import { useNavigate } from 'react-router';
import { useLocation } from 'react-router-dom';
import { TabSwitcher } from 'components';
import { OrgIntegrations, PermissionList, RolePermission, SaveParams } from 'utils';
import { Assessment } from './assessment';
import { Diagnoses } from './diagnoses';

export const clinicalTabEnums = {
    DIAGNOSES: 'DIAGNOSES',
    ASSESSMENT: 'ASSESSMENT',
};

/** Diagnoses are billing data too, so they don't need the clinical-sessions integration; assessments do. */
export const canSeeClientDiagnoses = () =>
    RolePermission([PermissionList.CLIENT_DIAGNOSIS_READ?.code, PermissionList.CLIENT_DIAGNOSIS_MANAGE?.code]);

export const useCanSeeClientAssessments = () => {
    const { cSession } = OrgIntegrations();
    return !!cSession && RolePermission([PermissionList.CLIENT_ASSESSMENT_READ?.code]);
};

export const Clinical = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const info = location?.state;
    const showAssessments = useCanSeeClientAssessments();
    const tabs = [
        canSeeClientDiagnoses() && { title: 'Diagnoses', tabValue: clinicalTabEnums.DIAGNOSES },
        showAssessments && { title: 'Assessment', tabValue: clinicalTabEnums.ASSESSMENT },
    ].filter(Boolean);
    const activeTab = tabs.some((tab) => tab.tabValue === info?.clinicalTab) ? info.clinicalTab : tabs[0]?.tabValue;
    const [actionsSlot, setActionsSlot] = useState(null);

    return (
        <div>
            <div className="clinical-sub-header">
                {tabs.length > 1 && (
                    <TabSwitcher list={tabs} tab={activeTab} setTab={(clinicalTab) => SaveParams(navigate, { ...info, clinicalTab })} />
                )}
                <div className="clinical-sub-header-actions" ref={setActionsSlot} />
            </div>
            {activeTab === clinicalTabEnums.DIAGNOSES ? <Diagnoses actionsSlot={actionsSlot} /> : <Assessment actionsSlot={actionsSlot} />}
        </div>
    );
};
